import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useBulkContactToggleTextSubscriptionMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ISystemJob, variables: Api.IContactsAutomatedSmsOptOutRequest) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: Api.IContactsAutomatedSmsOptOutRequest) =>
			userSession.webServiceHelper.callAsync<Api.ISystemJob>('contact/automatedSMSOptOut/bulk', 'POST', request),
		onSuccess,
		onError,
	});
}
